import React from 'react'
import { Grid } from '@mui/material'

import ErrorPage from 'components/ErrorPage'

import notFound from 'assets/images/notFound.webp'

const NotFound = () => {
  return (
    <Grid height="100vh">
      <ErrorPage
        img={notFound}
        title="404 - Beauty Uncharted"
        description="Oops! It seems like you've wandered into uncharted territory."
        alt="not found"
      />
    </Grid>
  )
}

export default NotFound
